export default __webpack_public_path__ + "static/media/video-97053_1920.5f13d134.jpg";